import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2.75A6.25 6.25 0 0 0 5.75 9v5A3.75 3.75 0 0 1 5 16.25h14a3.75 3.75 0 0 1-.75-2.25V9A6.25 6.25 0 0 0 12 2.75m10 13.5A2.25 2.25 0 0 1 19.75 14V9a7.75 7.75 0 1 0-15.5 0v5A2.25 2.25 0 0 1 2 16.25a.75.75 0 0 0 0 1.5h20a.75.75 0 0 0 0-1.5M9.894 20.351a.75.75 0 0 1 1.025.273 1.25 1.25 0 0 0 2.162 0 .75.75 0 0 1 1.298.752 2.75 2.75 0 0 1-4.758 0 .75.75 0 0 1 .273-1.025",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }